<template>
  <div class="issues-category-summary-container">
    <div class="issues-category-summary page-content row">
      <IssuesCategoryItem
        v-for="(category, index) in issueCategories"
        :key="category.name + index"
        :categoryIssuesData="category"  />
    </div>
  </div>
</template>

<script>
import IssuesCategoryItem from '@/issues/IssuesCategoryItem.vue';

export default {
  props: ['issuesData'],
  components: {
    IssuesCategoryItem,
  },
  computed: {
    issueCategories() {
      return this.issuesData.errorCategories;
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';

</style>
